var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5ae9a566ec75a5da1020df1387abbeddb22dcd37"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["found-store@cct-ol"]={id:"5ae9a566ec75a5da1020df1387abbeddb22dcd37"};
      